import { fleetEnvironment } from '../fleet-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { simpleVehicleGroupSchema } from '../schemas/vehicle-group.schema';
import { withJwt } from '../../../utils/with-jwt';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Retrieves Vehicle Groups associated with a given Routing Profile
 * @param routingProfileId The ID of the Routing Profile whose Vehicle Groups are being retrieved
 * @returns Data object containing array of assigned Vehicle Group's IDs
 */
export function getRoutingProfileVehicleGroups(
  this: unknown,
  routingProfileId: number
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .routingProfileVehicleGroupsUrl(routingProfileId),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(simpleVehicleGroupSchema),
      })
    )
  );
}
